
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class HelpTextDialog extends SiteEntityDialog<HelpTextRow, any> {
        protected getFormKey() { return HelpTextForm.formKey; }
        protected getIdProperty() { return HelpTextRow.idProperty; }
        protected getLocalTextPrefix() { return HelpTextRow.localTextPrefix; }
        protected getNameProperty() { return HelpTextRow.nameProperty; }
        protected getService() { return HelpTextService.baseUrl; }

        protected form = new HelpTextForm(this.idPrefix);

    }
}